"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        TaskGuide_ShowSteps: "Show steps",
        TaskGuidesStep_BackStep: "Previous step",
        TaskGuidesStep_CollapseTitle: "Collapse",
        TaskGuidesStep_ExampleLabel: "Example",
        TaskGuidesStep_ExpandTitle: "Expand",
        TaskGuidesStep_NextStep: "Skip this step",
        TaskGuidesStep_NoteLabel: "Note",
        TaskRecorder_EditStep: "Edit step",
        TaskRecorder_RecordingInProgress: "Task recording in progress",
        TaskRecorder_ScenarioName: "Test Scenario Name",
    });
    var ax;
    (function (ax) {
        var taskGuide;
        (function (taskGuide) {
            /** Used in the task guide chain to position the blocking divs around the Task Guide tooltip target. */
            var RailsModeComponent = /** @class */ (function () {
                function RailsModeComponent(controller) {
                    var _this = this;
                    this.dispose = function () {
                        var e_1, _a;
                        _this.railsModeTarget(null);
                        if (_this._surroundingBlockingDiv) {
                            _this._surroundingBlockingDiv.destroy();
                        }
                        _this._lastOpenedflyoutTarget = null;
                        $(document).off("flyoutRegistered", _this.flyoutRegisteredHandler);
                        $(document).off("flyoutRemoved", _this.flyoutRemovedHandler);
                        try {
                            for (var _b = __values(_this.subscriptions), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var subscription = _c.value;
                                if (subscription && subscription.dispose) {
                                    subscription.dispose();
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        _this.subscriptions = null;
                    };
                    this.flyoutRegisteredHandler = function () {
                        if ($dyn.flyout.flyoutManager.areAnyFlyoutsOpen()) {
                            var flyoutObject = $dyn.flyout.flyoutManager.getTopFlyout();
                            if (flyoutObject && flyoutObject.flyout) {
                                var flyout_1 = $dyn.value(flyoutObject.flyout);
                                if (flyout_1 && flyout_1.length > 0) {
                                    // Save flyout target element
                                    _this._lastOpenedflyoutTarget = _this.railsModeTarget();
                                    _this.railsModeTarget(null);
                                }
                            }
                        }
                    };
                    this.flyoutRemovedHandler = function () {
                        if (_this._lastOpenedflyoutTarget) {
                            _this.railsModeTarget(_this._lastOpenedflyoutTarget);
                        }
                        _this.resetTopFlyoutTargetTracker();
                    };
                    this.subscriptions = [];
                    this._blockRenderTimer = null;
                    this.railsModeTarget = $dyn.observable(null);
                    this._lastOpenedflyoutTarget = null;
                    this._railsModeBlocksExist = $dyn.observable(false);
                    this._surroundingBlockingDiv = new $dyn.shell.surroundingBlockingDiv($dyn.ax.taskRecording.animatetaskGuideQTip, ["taskGuide-ignoreObscurityError", "applicationShell-surroundingBlockingDiv"]);
                    $(document).on("flyoutRegistered", this.flyoutRegisteredHandler);
                    $(document).on("flyoutRemoved", this.flyoutRemovedHandler);
                    this.subscriptions.push($dyn.observe(this._railsModeBlocksExist, function (blocksExist) {
                        $dyn.util.flyout.forceFlyoutSelection = blocksExist;
                    }));
                    this.subscriptions.push($dyn.observe(function () {
                        return $dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState) &&
                            $dyn.value($dyn.ax.taskRecording.taskGuideRailsMode) &&
                            $dyn.value(_this.railsModeTarget);
                    }, function (railsModeTarget) {
                        if (!railsModeTarget && !$dyn.value(_this._railsModeBlocksExist)) {
                            // target is null and blocks already removed, do nothing
                            return;
                        }
                        _this._onRenderBlocks();
                    }));
                }
                RailsModeComponent.prototype.setup = function (input, output) {
                    var _this = this;
                    this.input = input;
                    this.output = output;
                    this.subscriptions.push($dyn.observe(input, function (guidedStep) {
                        _this.evaluateRailsModeBlocks(guidedStep);
                    }));
                };
                RailsModeComponent.prototype.evaluateRailsModeBlocks = function (guidedStep) {
                    this.resetTopFlyoutTargetTracker();
                    if (!guidedStep) {
                        return;
                    }
                    var options = guidedStep.options;
                    var target = options.target && $(options.target);
                    var shadow = options.shadowTarget && $(options.shadowTarget);
                    if (shadow || !target || !target[0] || options.avoidRailsModeBlocks) {
                        this.railsModeTarget(null);
                    }
                    else {
                        this.railsModeTarget(target);
                    }
                    this.output(guidedStep, true);
                };
                RailsModeComponent.prototype._renderBlocks = function () {
                    if ($dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState) &&
                        $dyn.value($dyn.ax.taskRecording.taskGuideRailsMode) &&
                        ($dyn.value(this.railsModeTarget) != null)) {
                        this._surroundingBlockingDiv.show($dyn.value(this.railsModeTarget));
                        this._railsModeBlocksExist(true);
                    }
                    else if ($dyn.value(this._railsModeBlocksExist)) {
                        this._surroundingBlockingDiv.hide();
                        this._railsModeBlocksExist(false);
                    }
                    this._blockRenderTimer = undefined;
                };
                RailsModeComponent.prototype._onRenderBlocks = function () {
                    this._renderBlocks();
                };
                RailsModeComponent.prototype.resetTopFlyoutTargetTracker = function () {
                    this._lastOpenedflyoutTarget = null;
                };
                return RailsModeComponent;
            }());
            taskGuide.RailsModeComponent = RailsModeComponent;
        })(taskGuide = ax.taskGuide || (ax.taskGuide = {}));
    })(ax = $dyn.ax || ($dyn.ax = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=RailsModeComponent.js.map
